import { css } from 'styled-components';
import { ColorProps, colors } from './color';
import { FontWeightProps } from './font';
import { displayHelperStyle, DisplayHelperStyledAttrProps } from './display';

export type AlignProps = 'left' | 'right' | 'center' | 'justify';
export type AlignContentProps = 'flex-start' | 'flex-end' | 'center' | 'stretch' | 'space-between' | 'space-around';
export type AlignItemsProps =
  | 'flex-start'
  | 'flex-end'
  | 'center'
  | 'baseline'
  | 'stretch'
  | 'inherit'
  | 'initial'
  | 'unset';
export type FloatProps = 'left' | 'right' | 'none';
export type JustifyContentProps =
  | 'center'
  | 'start'
  | 'end'
  | 'flex-start'
  | 'flex-end'
  | 'left'
  | 'right'
  | 'baseline'
  | 'first baseline'
  | 'last baseline'
  | 'space-between'
  | 'space-around';

export interface HelperProps extends DisplayHelperStyledAttrProps {
  $align?: AlignProps;
  $alignContent?: AlignContentProps;
  $alignItems?: AlignItemsProps;
  $bgColor?: ColorProps;
  $clearfix?: boolean;
  $color?: ColorProps;
  $float?: FloatProps;
  $fontWeight?: FontWeightProps;
  $justifyContent?: JustifyContentProps;
  $letterSpacing?: number;
  $radius?: number;
  $p?: Array<number>;
  $pt?: number;
  $pr?: number;
  $pb?: number;
  $pl?: number;
  $m?: Array<number | 'auto'>;
  $mt?: number | 'auto';
  $mr?: number | 'auto';
  $mb?: number | 'auto';
  $ml?: number | 'auto';
}

export const marginStyle = (value?: number | 'auto') => (value === 'auto' ? value : `${value}px`);

export const helperStyles = ({
  $align,
  $alignContent,
  $alignItems,
  $bgColor,
  $clearfix,
  $color,
  $display,
  $float,
  $fontWeight,
  $justifyContent,
  $letterSpacing,
  $radius,
  $p,
  $pt,
  $pr,
  $pb,
  $pl,
  $m,
  $mt,
  $mr,
  $mb,
  $ml,
}: HelperProps) => css`
  ${$align &&
    css`
      text-align: ${$align} !important;
    `}
  ${$alignContent &&
    css`
      align-content: ${$alignContent} !important;
    `}
  ${$alignItems &&
    css`
      align-items: ${$alignItems} !important;
    `}
  ${$bgColor &&
    css`
      background-color: ${colors[$bgColor]} !important;
    `}
  ${$clearfix &&
    css`
      &:after {
        height: 0;
        display: table;
        content: '';
        clear: both;
      }
    `}
  ${$color &&
    css`
      color: ${colors[$color]} !important;
    `}
  ${$display && displayHelperStyle($display)}
  ${$float &&
    css`
      float: ${$float} !important;
    `}
  ${$fontWeight &&
    css`
      font-weight: ${$fontWeight} !important;
    `}
  ${$justifyContent &&
    css`
      justify-content: ${$justifyContent} !important;
    `}
  ${$letterSpacing &&
    css`
      letter-spacing: ${$letterSpacing}px !important;
    `}
  ${$radius &&
    css`
      border-radius: ${$radius}px !important;
    `}
  ${$p &&
    css`
      padding: ${$p.map(e => `${e}px`).join(' ')} !important;
    `}
  ${($pt || $pt === 0) &&
    css`
      padding-top: ${$pt}px !important;
    `}
  ${($pr || $pr === 0) &&
    css`
      padding-right: ${$pr}px !important;
    `}
  ${($pb || $pb === 0) &&
    css`
      padding-bottom: ${$pb}px !important;
    `}
  ${($pl || $pl === 0) &&
    css`
      padding-left: ${$pl}px !important;
    `}
  ${$m &&
    css`
      margin: ${$m.map(m => marginStyle(m)).join(' ')} !important;
    `}
  ${($mt || $mt === 0) &&
    css`
      margin-top: ${marginStyle($mt)} !important;
    `}
  ${($mr || $mr === 0) &&
    css`
      margin-right: ${marginStyle($mr)} !important;
    `}
  ${($mb || $mb === 0) &&
    css`
      margin-bottom: ${marginStyle($mb)} !important;
    `}
  ${($ml || $ml === 0) &&
    css`
      margin-left: ${marginStyle($ml)} !important;
    `}
`;
